export const licenseKey =
  "ewogICJmb3JtYXQiOiAxLAogICJjdXN0b21lcklkIjogImY5ZDJiNWNlLWZlMTQtNGFkMC1iZjI4LWI1MjliZmFkOTNjZCIsCiAgIm1heFZlcnNpb25BbGxvd2VkIjogMjQyCn0=.Wim7N7SC/t6K1oNxUsyWpu7qWcO6aBhVV0bfMB/O1ekSSUM4B9mNqXgqK0ZocJsuyRVZ8Spe3ruUJ3IpGG6/ocGC1H+i2ZFxOVV6J95VOqULzaaDP65fbV0KWiNYBi8auMuGrQ==";
